import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SalaryGridService } from '../../../../../core/services/salary-grid.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-salary-grid',
  templateUrl: './salary-grid.component.html',
  imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgxPaginationModule],
  styleUrls: ['./salary-grid.component.css']
})
export class SalaryGridComponent {
  buttonsPermission: any;
  search_text = '';
  data: any[] = [];
  selected_data: any;
  loading = false;
  form: any = this.emptyForm();

  readonly CATEGORIES = ['Enseignant', 'Administratif', 'Service', 'Direction', 'Surveillance', 'Autre'];
  pg = { pageSize: 10, p: 0, total: 0 };

  constructor(
    private gridService: SalaryGridService,
    private toastrService: ToastrService,
    config: NgbModalConfig,
    private modalService: NgbModal
  ) { config.backdrop = 'static'; config.keyboard = false; }

  ngOnInit(): void {
    this.buttonsPermission = { add: true, edit: true, delete: true };
    this.getAll();
  }

  emptyForm() {
    return { label: '', category: '', base_salary: 0, transport_allowance: 0, housing_allowance: 0, other_allowance: 0, description: '', is_active: true };
  }

  totalAllowances(g: any): number {
    return (+g.transport_allowance || 0) + (+g.housing_allowance || 0) + (+g.other_allowance || 0);
  }
  gross(g: any): number { return (+g.base_salary || 0) + this.totalAllowances(g); }

  getAll() {
    this.loading = true;
    this.gridService.getAll().subscribe((res: any) => {
      this.loading = false; this.data = res.data ?? []; this.pg.total = this.data.length;
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Grilles salariales', err); });
  }

  store(value: any) {
    this.loading = true;
    this.gridService.store(value).subscribe((res: any) => {
      this.loading = false; this.toastrService.success(res.message); this.modalService.dismissAll(); this.form = this.emptyForm(); this.getAll();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Grilles salariales', err); });
  }

  update(value: any) {
    this.loading = true;
    this.gridService.update(this.selected_data.id, value).subscribe((res: any) => {
      this.loading = false; this.toastrService.success(res.message); this.modalService.dismissAll(); this.getAll();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Grilles salariales', err); });
  }

  delete() {
    if (!this.verifyChecked()) return;
    AppSweetAlert.confirmBox('info', 'Suppression', 'Supprimer cette grille salariale ?').then((r: any) => {
      if (r.isConfirmed) this.gridService.delete(this.selected_data.id).subscribe((res: any) => {
        this.toastrService.success(res.message); this.getAll();
      }, (err: any) => AppErrorShow.showError('Grilles salariales', err));
    });
  }

  checked(el?: any) { this.selected_data = el; }
  verifyChecked() { if (!this.selected_data) { this.toastrService.warning('Aucun élément sélectionné'); return false; } return true; }
  add(c: any) { this.form = this.emptyForm(); this.modalService.open(c, { size: 'lg' }); }
  edit(c: any) { if (!this.verifyChecked()) return; this.form = { ...this.selected_data }; this.modalService.open(c, { size: 'lg' }); }
  getPage(e: any) { this.pg.p = e; }
}
